// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'row',
    margin: '15px 0 25px 0',
    width: '100%',
  },
  inputContainer: {
    display: 'flex',
    position: 'relative',
    width: '100%',
  },
  input: {
    width: '100%',
    height: 45,
    border: 'none',
    boxShadow: '0px 0px 5px rgba(0,0,0,0.3)',
    borderRadius: 1,
    padding: '8px 10px 5px 50px',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    '&::-webkit-input-placeholder': {
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
      color: 'rgb(150, 150, 150)',
    },
    '&::placeholder': {
      fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
      color: 'rgb(150, 150, 150)',
    },
  },
  searchIcon: {
    top: 12,
    left: 15,
    position: 'absolute',
    width: 20,
    height: 20,
  }
});

export default styles;
